/**
 * Custom JS
 *
 */

function init() {
  function initProductCards() {
    const selectors = {
      productCards: '[data-product-card]',
    }

    const elements = {
      productCards: document.querySelectorAll(selectors.productCards),
    }

    if (elements.productCards.length > 0) {
      elements.productCards.forEach((card) => {
        const $card = $(card);
        const $form = $('form', $card);
        theme.applyAjaxToProductForm($form)
      });
    }
  }

  initProductCards();
}

document.addEventListener("DOMContentLoaded", () => {
  init();
});

document.addEventListener("Theme:retrigger", () => {
  init();
});

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);
